import { OmnibarEntry } from '../omnibar-interfaces';
import { OmnibarAuthorityCitizen } from '../omnibar-provider';

export default function entryAuthorityCitizenFilter(option: OmnibarEntry, authorityCitizen: OmnibarAuthorityCitizen | undefined) {
  if (!authorityCitizen) return true;
  if (option.employmentOpticOnly && !authorityCitizen.isEmploymentOptic) return false;
  if (option.hideForAnonymousCitizen && authorityCitizen.isAnonymous) return false;
  return true;
}
